// How an environment is named and coloured wherever the admin shows it — the
// consent screen and the MCP access page have to agree, so it is said once.

interface EnvironmentLook {
  label: string;
  variant: "danger" | "info" | "neutral";
}

const LOOKS: Record<string, EnvironmentLook> = {
  production: { label: "Production", variant: "danger" },
  development: { label: "Development", variant: "info" },
  local: { label: "Local", variant: "neutral" },
};

/** An unknown value is still printed, uncoloured, rather than hidden. */
export function environmentLook(env: string): EnvironmentLook {
  return LOOKS[env] ?? { label: env, variant: "neutral" };
}

/** The environment as a word inside a sentence: "production". */
export function environmentWord(env: string): string {
  return environmentLook(env).label.toLowerCase();
}
